import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export async function getStory(token: string): Promise<StoryInfo> {
  return await apiFetch(`${API_BASE}/api/management/story`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function getStoryHistory(token: string): Promise<StoryInfo[]> {
  return await apiFetch(`${API_BASE}/api/management/story-history`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function getProgress(token: string): Promise<ProgressInfo> {
  return await apiFetch(`${API_BASE}/api/management/story-progress`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function saveProgress(token: string, id: number, thumb_up: boolean, thumb_down: boolean): Promise<ProgressInfo> {
  return await apiFetch(`${API_BASE}/api/management/story-progress`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({id: id, thumb_up: thumb_up, thumb_down: thumb_down}),
  });
}

export async function getComment(token: string): Promise<CommentInfo> {
  return await apiFetch(`${API_BASE}/api/management/story-comment`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function saveComment(token: string, id: number, thumb_up: boolean, thumb_down: boolean): Promise<CommentInfo> {
  return await apiFetch(`${API_BASE}/api/management/story-comment`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({id: id, thumb_up: thumb_up, thumb_down: thumb_down}),
  });
}

export interface StoryInfo {
    story_id: number;
    sinario: number;
    title: string;
    content: string;
    story_created_at: string;
    user_story_id: number;
    status: string;
    started_at: string;
    completed_at: string;
    updated_at: string;
}

export interface ProgressInfo {
    id: number;
    prefecture_id: number;
    name: string;
    history_culture: string;
    specialty_products: string;
    recommended_attractions: string;
    thumb_up: boolean;
    thumb_down: boolean;
}

export interface CommentInfo {
    id: number;
    user_id: number;
    comment_type: number;
    title: string;
    content: string;
    ai_comment_up: boolean;
    ai_comment_down: boolean;
    created_at: string;
    partner_title: string;
    partner_image_url: string;
    partner_voice_name: string | null;
}
